import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';

import { Angulartics2RouterlessModule } from 'angulartics2';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { take, tap } from 'rxjs';

import { ServerDate } from '@tablesready/server-time';
import {
  LoaderModule,
  UtilsModule,
  GlobalErrorHandler,
  ServerTimeService,
} from '@tablesready/common-ui';
import { PROVIDERS } from './providers';
import { AppRouterModule } from './app-router.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { ApiClientModule, ApiClientService } from '@tablesready/api-client';
import {
  AppVariablesModule,
  appVariablesProvider,
  AppVariablesService,
} from '@tablesready/frontend-variables';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { IonicModule } from '@ionic/angular';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { ErrorInterceptor } from '@tablesready/common-ui';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  imports: [
    ApiClientModule,
    BrowserModule,
    AlertsModule,
    LoaderModule,
    AppRouterModule,
    FrontendModalModule,
    AppVariablesModule,
    IonicModule.forRoot(),
    AngularSvgIconModule.forRoot(),
    UtilsModule,
    FrontendIconsModule,
    Angulartics2RouterlessModule.forRoot(),
    AlertsModule.forRoot(),
  ],
  providers: [
    appVariablesProvider,
    AppVariablesService,
    ApiClientService,
    {
      provide: 'LOG_ERRORS',
      useValue: environment.logErrors,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (appVariablesService: AppVariablesService) => {
        return () => appVariablesService.getAppVariables().toPromise();
      },
      multi: true,
      deps: [AppVariablesService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (serverTimeService: ServerTimeService) => {
        return () => {
          return serverTimeService.offset$
            .pipe(
              tap(offset => {
                ServerDate.setOffset(offset)
              }),
              take(1),
            )
        };
      },
      multi: true,
      deps: [ServerTimeService],
    },
    ...PROVIDERS,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule { }
